export default __webpack_public_path__ + "static/media/appStore@2x.02ec73f4.png";